export const stop = (event) => (event.stopPropagation(), event);
